import { render } from "./SitzungBeitreten.vue?vue&type=template&id=394c6f34&scoped=true"
import script from "./SitzungBeitreten.vue?vue&type=script&lang=js"
export * from "./SitzungBeitreten.vue?vue&type=script&lang=js"

import "./SitzungBeitreten.vue?vue&type=style&index=0&id=394c6f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394c6f34"]])

export default __exports__